export default "__VITE_ASSET__195db6e4__"